import {
  Directive,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { CanDisable, mixinDisabled } from '@angular/material/core';
import { BehaviorSubject, mergeMap, of, Subscription } from 'rxjs';
import { AuthService } from './auth.service';

const NeedPermissionBase = mixinDisabled(class {});

@Directive({
  selector: 'button[atmNeedPermissionButton], button[need-permission]',
})
export class NeedPermissionButtonDirective
  extends NeedPermissionBase
  implements CanDisable, OnInit, OnDestroy
{
  override get disabled(): boolean {
    return this.button?.disabled ?? this._disabled;
  }
  override set disabled(disabled: boolean) {
    this._disabled = disabled;
    if (this.button) {
      this.button.disabled = disabled;
    }
  }
  private _disabled = true;

  @HostBinding('attr.disabled')
  get attrDisabled(): true | null {
    return this._disabled || null;
  }
  @HostBinding('attr.aria-disabled')
  get attrAriaDisabled(): string {
    return this._disabled.toString();
  }

  @Input('need-permission')
  get needPermission(): string | undefined {
    return this.glxNeedPermission;
  }
  set needPermission(permission: string | undefined) {
    this.glxNeedPermission = permission;
  }

  @Input()
  get glxNeedPermission(): string | undefined {
    return this.neededPermissionSubject.value;
  }
  set glxNeedPermission(permission: string | undefined) {
    this.neededPermissionSubject.next(permission);
  }
  private neededPermissionSubject = new BehaviorSubject<string | undefined>(
    undefined
  );
  private permissionSub = Subscription.EMPTY;

  constructor(
    private auth: AuthService,
    @Optional() private button: MatButton | null
  ) {
    super();
  }

  ngOnInit(): void {
    this.permissionSub = this.neededPermissionSubject
      .pipe(
        mergeMap((permission) => {
          if (!permission) {
            return of(true);
          }
          return this.auth.curentUserHasPermission(permission);
        })
      )
      .subscribe((hasPermission) => {
        this.disabled = !hasPermission;
      });
  }

  ngOnDestroy(): void {
    this.permissionSub.unsubscribe();
  }
}
